<template>
  <div v-if="blogList.length">
    <div class="columns is-relative is-flex-direction-row-reverse">
      <span class="pointer pt-4 pr-3 is-hidden-mobile" @click="rightScroll()">
        <vue-icon-base
          height="20"
          width="20"
          :path="$options.icons[$kc('uni-arrow-circle-right')]"
        >
        </vue-icon-base
      ></span>
      <span
        class="mr-3 pointer pt-4 pr-3 is-hidden-mobile"
        @click="leftScroll()"
      >
        <vue-icon-base
          height="20"
          width="20"
          :path="$options.icons[$kc('uni-arrow-circle-left')]"
        >
        </vue-icon-base
      ></span>
    </div>
    <div class="is-flex scroll-images employer-card gap-1 overflow-hidden pb-5">
      <div
        v-for="(blog, index) in blogList"
        :key="index"
        class="rounded-10 flex-overflow transition-05s"
        :class="screen === 'mobile' ? 'max-width-43' : ''"
      >
        <img
          :src="blog.image"
          class="pointer"
          @click="openDetailPage(blog.slug)"
        />
        <div class="px-2 mb-2">
          <div
            :title="blog.title"
            class="is-size-6 title pointer"
            @click="openDetailPage(blog.slug)"
          >
            {{ blog.title }}
          </div>
          <span class="has-text-grey-light is-size-7">
            {{ $options.getMoment(blog.created_at) }}
            |{{ blog.category.name }}</span
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getMoment } from '@/helpers/utils/date'
import { truncateChars } from '@/helpers/utils/common'
import { mapGetters } from 'vuex'
import VueIconBase from '@/components/Commons/VueIconBase'
import { uniArrowCircleRight, uniArrowCircleLeft } from '@/helpers/icons'
export default {
  components: {
    VueIconBase
  },
  getMoment,
  truncateChars,
  icons: {
    uniArrowCircleRight,
    uniArrowCircleLeft
  },
  data() {
    return {
      blogList: {}
    }
  },
  computed: {
    ...mapGetters({ screen: 'getScreen' })
  },
  mounted() {
    this.getRandomBlogs()
  },
  methods: {
    rightScroll() {
      const left = document.querySelector('.scroll-images')
      left.scrollBy(200, 0)
    },
    leftScroll() {
      const right = document.querySelector('.scroll-images')
      right.scrollBy(-200, 0)
    },
    getRandomBlogs() {
      this.loading = true
      const contentUrl = `/api/v1/blogs/random/`
      this.$axios
        .get(contentUrl)
        .then(response => {
          this.blogList = response.data
        })
        .finally(() => {
          this.loading = false
        })
    },
    openDetailPage(slug) {
      this.$router.push(
        this.localePath({
          name: 'blog-detail-slug',
          params: { slug }
        })
      )
    }
  }
}
</script>
<style lang="css">
.hero.has-background {
  position: relative;
  overflow: hidden;
  height: 350px;
}
.hero-background {
  position: absolute;
  width: 100%;
  height: 100% !important;
}
.has-opacity-half {
  opacity: 0.85;
}
</style>
